<template>
  <transition name="modal" mode="in-out">
    <modal v-if="show"
           :title="'Salvar visão'"
           :errors="errors"
           :closemodal="handleClose"
           :size="'modal-sm'"
           :params="form"
           @salvar="handleSalvar">
      <template v-slot:body="slotProps">
        <form>
          <div class="form-group">
            <label class="col-form-label">Nome da visão</label>
            <input type="text"
                   v-model="slotProps.params.Nome"
                   class="form-control form-control-sm"
                   maxlength="100"
                   placeholder="Ex: Minhas despesas pendentes" />
          </div>
        </form>
      </template>
      <template v-slot:footer="slotFooterProps">
        <button class="btn btn-sm pull-right btn-primary modal-confirm" @click="slotFooterProps.clickHandler('salvar')">Salvar</button>
      </template>
    </modal>
  </transition>
</template>

<script>
// Modal reutilizável para salvar a combinação de filtros atualmente aplicada como uma
// "visão" custom do usuário (item 3 da reforma de UX). `salvarVisaoAtual` é o método já
// existente no mixin consultar.js (POST /configuracoes/visoes) — cada tela só precisa
// colocar esta tag e passar sua própria função/estado.
export default {
    props: {
        show: { type: Boolean, default: false },
        salvarVisaoAtual: { type: Function, required: true }
    },
    data() {
        return {
            form: { Nome: '' },
            errors: []
        };
    },
    watch: {
        show(isShown) {
            if (isShown) {
                this.form = { Nome: '' };
                this.errors = [];
            }
        }
    },
    methods: {
        handleClose() {
            this.$emit('close');
        },
        handleSalvar() {
            if (!this.form.Nome) {
                this.errors = ['Informe um nome para a visão.'];
                return;
            }
            this.salvarVisaoAtual(this.form.Nome).then(() => {
                this.$emit('close');
            });
        }
    }
};
</script>
